import React from 'react';

import styled from '@emotion/styled';

import { Alert, Button, Modal } from '@shared/components/bootstrap';

import { client } from '@admin/libraries/apollo';
import { Status, User, useUserDeleteMutation } from '@admin/schema';

const Title = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
`;

const Summary = styled.p`
  font-size: 18px;
  font-weight: 200;
  line-height: 24px;
  text-align: center;
`;

const Buttons = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
`;

export const Delete: React.FC<{
  user: Pick<User, 'id' | 'name'>;
  onClose(): void;
}> = ({ onClose, user }) => {
  const [execute, { data, loading }] = useUserDeleteMutation({ client, variables: { id: user.id } });

  const onConfirm = async () => {
    const result = await execute();
    if (result?.data?.result.status === Status.Ok) {
      onClose();
    }
  };

  return (
    <Modal onClose={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Close close={onClose} />
        </Modal.Header>
        <Modal.Body>
          {data?.result?.error && <Alert style="danger">{data.result.error}</Alert>}
          <Title>Delete "{user.name}"</Title>
          <Summary>Are you sure you want to delete "{user.name}"?</Summary>
        </Modal.Body>
        <Modal.Footer>
          <Buttons>
            <Button disabled={loading} kind="default" onClick={onClose} size="lg">
              No
            </Button>
            <Button loading={loading} kind="danger" onClick={onConfirm} size="lg">
              Yes
            </Button>
          </Buttons>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
